import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/** Shown to guest accounts: set a password on their WhatsApp number so they
 * can log in from any phone. Same user id — shop & products stay linked. */
export default function ClaimAccountCard({ defaultMobile = "" }) {
  const { user, refresh } = useAuth();
  const [mobile, setMobile] = useState(defaultMobile || user?.whatsapp || user?.mobile || "");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  if (!user?.is_guest || done) return null;

  const digits = (mobile || "").replace(/\D/g, "");
  const ok = digits.length >= 10 && digits.length <= 15 && password.length >= 6;

  const submit = async () => {
    if (!ok || busy) return;
    setBusy(true);
    try {
      const res = await api.post("/auth/claim", { password, mobile: digits });
      localStorage.setItem("ibloom_token", res.data.token);
      await refresh();
      setDone(true);
      toast.success(`Saved! Log in with ${digits} + your password from any phone.`);
    } catch (e) {
      const d = e?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Couldn't save — try again.");
    } finally {
      setBusy(false);
    }
  };

  const inputSt = { width: "100%", padding: "10px 12px", borderRadius: 10, border: "1px solid #DDD8C8", fontSize: 13.5, background: "#FCFBF7", boxSizing: "border-box" };

  return (
    <div data-testid="claim-account-card" style={{ background: "white", border: "1px solid #EAE8DC", borderRadius: 18, padding: 18, marginTop: 14, textAlign: "left" }}>
      <div style={{ fontSize: 14.5, fontWeight: 800, color: "#0F3D2E" }}>🔐 Save your shop login</div>
      <p style={{ fontSize: 12, color: "#666", lineHeight: 1.5, margin: "6px 0 12px" }}>
        Set a password for your WhatsApp number so you can log in to this shop from any phone.
      </p>
      <input
        data-testid="claim-mobile-input"
        type="tel"
        placeholder="WhatsApp number (10 digits)"
        value={mobile}
        onChange={(e) => setMobile(e.target.value)}
        style={inputSt}
      />
      <input
        data-testid="claim-password-input"
        type="password"
        placeholder="Choose a password (min 6 characters)"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        style={{ ...inputSt, marginTop: 8 }}
      />
      <button
        data-testid="claim-submit-btn"
        onClick={submit}
        disabled={!ok || busy}
        style={{ marginTop: 12, width: "100%", padding: 12, borderRadius: 100, border: "none", fontSize: 13.5, fontWeight: 800, cursor: ok && !busy ? "pointer" : "default", color: "white", background: ok && !busy ? "#0F3D2E" : "#B9B4A5" }}
      >
        {busy ? "Saving…" : "Save my login"}
      </button>
    </div>
  );
}
